<template>
    <div class="content-image-wrap">
        <div class="image-wrapper" :class="data.layout">
            <NuxtImg provider="kontentAiProvider" class="img-fluid" alt="..." v-if="data.image" :src="data.image.url" />
        </div>
        <div class="content">
            <RichText :value="data.content" />
        </div>
    </div>
</template>

<script setup lang="ts">
import type { ContentImageWrapModel } from '~/models';


const props = defineProps<{ model: ContentImageWrapModel }>();

const data = {
    content: props.model.elements.content.value,
    image: firstOrDefault( props.model.elements.image.value),
    layout: firstOrDefault(props.model.elements.layout.value)?.codename,
}
</script>
